// removed by extract-text-webpack-plugin
module.exports = {"container":"_1hcW_vIaGwWxBgHoERGYtF","buttons":"_1IJh0BJ_fOiHIsQUHTRr_A"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ConfirmationDialog/style.scss
// module id = 948
// module chunks = 0